<template>
  <svg
    id="Email_verified"
    data-name="Email verified"
    xmlns="http://www.w3.org/2000/svg"
    width="110"
    height="110"
    viewBox="0 0 110 110"
  >
    <path
      id="Path_8678"
      data-name="Path 8678"
      d="M0,0H110V110H0Z"
      fill="none"
    />
    <path
      id="Path_8679"
      data-name="Path 8679"
      d="M79.183,42.434,92.53,66.153a8.765,8.765,0,0,1-7.636,13.063H58.205A8.762,8.762,0,0,1,50.57,66.153L63.916,42.434a8.754,8.754,0,0,1,15.267,0ZM84.5,28.8V6.033M38.667,60.882H15.75A13.749,13.749,0,0,1,2,47.132V6.033"
      transform="translate(7.167 21.618)"
      fill="none"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
    <path
      id="Path_8680"
      data-name="Path 8680"
      d="M36.843,37.293,6.973,21.559A9.321,9.321,0,0,1,2,13.318v-.151A9.164,9.164,0,0,1,11.167,4H75.182A9.317,9.317,0,0,1,84.5,13.318v.092a9.17,9.17,0,0,1-4.9,8.113L49.657,37.3a13.786,13.786,0,0,1-12.815,0Zm34.7,29.141V58.4m0,16.908a.392.392,0,0,0-.394.4.4.4,0,1,0,.394-.4"
      transform="translate(7.167 14.333)"
      fill="none"
      :stroke="clr"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
    />
  </svg>
</template>
<script>
export default {
  props: ["clr"]
};
</script>
